import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $utils from "@/lib/utils/index.js";

const ifilVendorContract = require('./ifilVendorContract.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.ifilVendorContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(ifilVendorContract.abi, contractAddress) : '',
}

const getIfilVendorAddress = () => {
  return contractAddress;
}

const getIfilVendorContract = () => {
  return contractConst.contract;
}

const vendorActiveABS = ([_prodid], options, callback) => {
  return $web3js.send(getIfilVendorContract().methods.activeABS, [_prodid], options, callback);
}

const vendorActiveABSEstimateSend = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getIfilVendorContract().methods.activeABS, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const vendorWithdraw = ([_prodid], options, callback) => {
  return $web3js.send(getIfilVendorContract().methods.withdraw, [_prodid], options, callback);
}

const vendorWithdrawEstimateSend = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getIfilVendorContract().methods.withdraw, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

export default {
  getIfilVendorAddress,
  getIfilVendorContract,
  vendorActiveABS,
  vendorActiveABSEstimateSend,
  vendorWithdraw,
  vendorWithdrawEstimateSend,
}


// WEBPACK FOOTER //
// ./src/lib/contract/ifilVendor/index.js